import { getCurrentUser } from '@/api/auth';

import { setLoggedInUser } from '@/redux/auth/actions';
import { setTenant } from '@/redux/configs/actions';
import { setUserData } from '@/redux/user-data/actions';

import { Language } from '@/types/i18n';

import { useAppDispatch } from './redux';

export function useUpdateUser() {
  const dispatch = useAppDispatch();

  return async () => {
    const { user: updatedUser, requiredSections } = await getCurrentUser();

    dispatch(setLoggedInUser(updatedUser));
    dispatch(
      setUserData({
        user: updatedUser,
        requiredSections: requiredSections,
      }),
    );
    dispatch(
      setTenant({
        tenant: updatedUser.tenant,
        language: updatedUser.language as Language,
      }),
    );
  };
}
